export default __webpack_public_path__ + "images/process_3.svg?033d78425848cfccb9de7bc117b645b5";